'use strict';

module.exports = ['$scope', '$rootScope', '$controller', '$location', '$window', '$timeout', 'OrderSvc', 'MaterialSvc', 'MixDesignSvc', 'UserProfileSvc', 'PlantSvc', 'ModalSvc', 'CalendarNoteSvc', function ($scope, $rootScope, $controller, $location, $window, $timeout, OrderSvc, MaterialSvc, MixDesignSvc, UserProfileSvc, PlantSvc, ModalSvc, CalendarNoteSvc) {

    $controller('OrdersBaseCalendarCtrl', {$scope: $scope});

    // ------------------
    // Scope functions
    // ------------------
    $scope.$on("highlightOrder", function (event, tmpOrder) {
        $scope.hoveredOrderBundle = tmpOrder && tmpOrder.id;
    });

    $scope.getTotal = function (day, shift) {
        if (shift == "night") {
            return day.total_nightshift;
        }
        else if (shift == "day") {
            return day.total_dayshift;
        }
        else {
            return day.total;
        }
    };

    $scope.isOvercapacity = function (day, shift) {
        return day.outputs && $scope.getTotal(day, shift) > $scope.plantObj.max_capacity;
    };

    $scope.getInputMaterials = function (outputs) {
        // calculate the required input materials from a list of orders
        var mix_designs = $scope.mix_designs;
        var input_material_quantities = {};
        var material_id;
        var mix_design;
        var mix_component;
        var mix_design_quantity;

        // For each output material find all input materials and add their quantities
        for (var i = outputs.length - 1; i >= 0; i--) {
            material_id = parseInt(outputs[i].material_id);
            mix_design = mix_designs[material_id];
            mix_design_quantity = outputs[i].total;

            if (mix_design) {
                for (var j = mix_design.components.length - 1; j >= 0; j--) {
                    mix_component = mix_design.components[j];
                    // TODO At the moment the proportion is divided by 100 as an assumption
                    // this should be removed and proportion should be saved as fractions, not %
                    input_material_quantities[mix_component.material] = input_material_quantities[mix_component.material] || 0;
                    input_material_quantities[mix_component.material] += mix_design_quantity * mix_component.proportion / 100;
                }
            }
        }

        return input_material_quantities;
    };

    $scope.updateDetailedModeSetting = function () {
        $scope.calendar.detailMode = !$scope.calendar.detailMode;

        var settings = {
            calendar_settings: {
                detailed_mode_active: $scope.calendar.detailMode
            }
        };
        updatePlantSettings(settings);

        $scope.$broadcast("calendar-resize");
    };

    $scope.getFieldValue = function (field, order_date, output) {
        if (field == "customer") {
            return order_date.order.customer;
        } else if (field == "material") {
            return output.material_name;
        } else {
            const extraField = Array.findObject(order_date.order.extra_fields_data, 'key', field);
            return $scope.getExtraFieldValue(extraField);
        }
    };

    $scope.getExtraFieldValue = function (extraField) {
        if (extraField.type === 'Checkbox') {
            return extraField.value ? extraField.key : '';
        }
        return extraField.value || '';
    };

    $scope.openCalendarNoteDialog = function (config) {
        var modal = ModalSvc.calendarNoteModal.open(config, $scope);

        var opened_on_date = moment(config.on_date, $rootScope.dateFormat.moment);

        // update data for the day
        modal.result.then(function (res) {
            var on_date = moment(res.on_date, $rootScope.dateFormat.moment);

            refreshNotesDayData(on_date);

            if (!opened_on_date.isSame(on_date)) {
                refreshNotesDayData(opened_on_date);
            }
        });
    };

    $scope.openPopoverOnNotesTab = function (event, selectedDay) {
        event.stopPropagation();
        $scope.tab = "notes";
        $scope.selectDay(selectedDay);
    };

    $scope.openPopoverOnOrdersTab = function (event, selectedDay) {
        event.stopPropagation();
        $scope.tab = "orders";
        $scope.selectDay(selectedDay);
    };

    function refreshNotesDayData(on_date) {
        $scope.month.weeks.forEach(function (week) {
            week.weekdays.forEach(function (day) {
                // check if day is in the current month
                if (day.day > 0) {
                    var date = moment({year: day.year, month: day.month - 1, day: day.day});

                    if (date.isSame(on_date)) {
                        CalendarNoteSvc.list($rootScope.plant, {
                            year: day.year,
                            month: day.month,
                            day: day.day
                        }).success(function (data) {
                            day.notes = data;
                        });
                    }
                }
            });
        });
    }

    // ------------------
    // Data
    // ------------------
    MixDesignSvc.loadAll($scope.plant).success(function (data) {
        $scope.mix_designs = MixDesignSvc.listToIdMap(data);
    });

    MaterialSvc.list($scope.plant).success(function (data) {
        $scope.materialsById = MaterialSvc.listToIdMap(data);
    });

    PlantSvc.getOrderFields($rootScope.plant).then(function (result) {

        angular.forEach(result.data, function (item) {
            $scope.detailed_mode_fields.push({
                label: item.name,
                value: item.name
            });
        });
    });

    // ------------------
    // Helper functions
    // ------------------
    function updatePlantSettings(settings) {
        UserProfileSvc.updatePlantSettings($rootScope.plant, $rootScope.user_id, settings).then(function (result) {
            $rootScope.$emit('user-profile-plant-settings-updated', result.data);
        });
    }

    // ------------------
    // Watches
    // ------------------

    // watch for profile changes
    $scope.$watchCollection("plant_settings", function (newVal, oldVal) {
        if (angular.isDefined(newVal)) {
            $scope.calendar.detailMode = newVal.calendar_settings.detailed_mode_active;
            $scope.calendar.selected_detailed_mode_fields = newVal.calendar_settings.detailed_mode_fields != "" ? newVal.calendar_settings.detailed_mode_fields.split($rootScope.dbStringSeparator) : [];
        }
    });


    // watch for calendar settings changes
    $scope.$watchCollection("calendar.selected_detailed_mode_fields", function (newVal, oldVal) {

        if (angular.isUndefined(newVal)) return;

        if (angular.isDefined(fieldsUpdateTimer)) {
            $timeout.cancel(fieldsUpdateTimer);
        }

        if (newVal != oldVal) {
            $scope.$broadcast("calendar-resize");
        }

        var fields_as_string = newVal.join($rootScope.dbStringSeparator);

        if (fields_as_string != $scope.plant_settings.calendar_settings.detailed_mode_fields) {

            var settings = {
                calendar_settings: {
                    detailed_mode_fields: fields_as_string
                }
            };

            fieldsUpdateTimer = $timeout(function () {
                updatePlantSettings(settings);
            }, 1000);
        }
    });

    // ------------------
    // Initialization
    // ------------------

    // local vars
    var fieldsUpdateTimer;

    // $scope vars
    $scope.detailed_mode_fields = [
        {label: 'Customer', value: 'customer'},
        {label: 'Material', value: 'material'}
    ];

    $scope.materialsById = {};
    $scope.mix_designs = {};
    $scope.calendar = {
        detailMode: false
    };

    // init actions
    $scope.currentMonthClick();

    // new order intro
    const {showIntro} = $location.search();

    $location.search({showIntro: null});

    if (showIntro) {
        $timeout(() => {
            introJs().setOptions({
                showBullets: false,
                showStepNumbers: false,
                doneLabel: "Not now",
                steps: [{
                    element: document.querySelector('.new-order-btn'),
                    intro: "<b>Congratulations <span class='emoji'>👌</span></b></br>Please click on the 'New order' button to create your first order.",
                    position: "left",
                }]
            }).start();
        }, 1000);
    }

}];
